// ./src/config/apolloTypePolicies.ts
//
// The Apollo cache's type policies — in their own module so a guard can build a cache with them (`apollo.ts` has side
// effects at load).
//
// ⚠⚠ A type with an `id` field is NORMALISED by Apollo: stored once per `Type:id` and SHARED by every list that holds
//   it, and the result a query returns is read back from that store. A VALUE type that merely has an `id` (a card in a
//   list, not a record) then collapses: two lists in one answer holding `{ id: 'tasks' }` become ONE object, the last
//   written wins. Give such a type `keyFields: false` (stored inside its parent).
import type { TypePolicies } from "@apollo/client";

export const APOLLO_TYPE_POLICIES: TypePolicies = {
  // ROADMAP #190 review — `cards` (the event's) and `accountCards` (the default) in ONE answer both hold every card id;
  // normalised, the event's hidden flags were overwritten by the default's, so a card hidden on the event came back.
  EventDashboardCard: { keyFields: false },
};
